"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterParamsReducer = void 0;
const filterParams_1 = require("../actions/filterParams");
const initState = {
    preset: [],
    filter: [],
};
const filterParamsReducer = (filterParams = initState, action) => {
    switch (action.type) {
        case filterParams_1.SET_FILTER_PARAMS:
            return Object.assign({}, action.payload);
        default:
            return filterParams;
    }
};
exports.filterParamsReducer = filterParamsReducer;
//# sourceMappingURL=filterParams.reducer.js.map